import React, { useEffect, useRef, useState } from "react";

const useIsOpen = (
    initial: boolean = false
): [boolean, () => void, () => void, () => void] => {
    const [isOpen, setIsOpen] = useState(initial);
    
    // ✅ 新增：isMounted 检查防止内存泄漏
    const isMountedRef = useRef(true);
    
    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);
    
    // ✅ 包装所有的状态更新函数，仅在组件挂载时执行
    const safeSetOpen = () => {
        if (isMountedRef.current) setIsOpen(true);
    };
    
    const safeSetClosed = () => {
        if (isMountedRef.current) setIsOpen(false);
    };
    
    const safeToggle = () => {
        if (isMountedRef.current) setIsOpen((prev) => !prev);
    };
    
    return [
        isOpen,
        safeSetOpen,
        safeSetClosed,
        safeToggle,
    ];
};

export default useIsOpen;
